import { EBaseApiTags } from 'shared/typings';

import { enhancedApi } from './codegen.api';

export const transactionApi = enhancedApi.enhanceEndpoints({
	addTagTypes: [EBaseApiTags.TRANSACTION, EBaseApiTags.TRANSACTION_LIST],
	endpoints: {
		withdrawalRequestList: {
			providesTags: [EBaseApiTags.TRANSACTION_LIST],
		},
		withdrawalRequestCreate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.TRANSACTION_LIST]),
		},
		withdrawalRequestRetrieve: {
			providesTags: [EBaseApiTags.TRANSACTION],
		},
	},
});

export const {
	useWithdrawalRequestListQuery,
	useWithdrawalRequestCreateMutation,
	useWithdrawalRequestRetrieveQuery,
	useReportsBalanceTransactionsListQuery,
} = transactionApi;
